// extracted by mini-css-extract-plugin
module.exports = {"container":"ShaqvanaContainer_container__d7SHy"};